import {
  ApplicationConfig,
  importProvidersFrom,
  provideExperimentalZonelessChangeDetection,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withDebugTracing,
} from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  LOCAL_STORAGE_ENGINE,
  NgxsStoragePluginModule,
  SESSION_STORAGE_ENGINE,
  StorageOption,
  withNgxsStoragePlugin,
} from '@ngxs/storage-plugin';
import { routes } from './app.routes';
import { NgxsModule, provideStore } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { jwtInterceptor } from '@tsin-core/interceptors/jwt.interceptor';
import { loggingInterceptor } from '@tsin-core/interceptors/logging.interceptor';
import { environment } from '@tsin-env/environment';
import { AuthState } from '@tsin-states/auth.state';
import { UserState } from '@tsin-states/user.state';
import { ExaminerState } from '@tsin-core/states/examiner/examiner.state';
import { ExamineeState } from '@tsin-core/states/examinee/examinee.state';
import { ExamState } from '@tsin-states/exams/exams.state';
import { TrackManagementState } from '@tsin-states/track-management/track-management.state';
import { StationManagementState } from '@tsin-states/station-management/station-management.state';
import { AdmninistrationManagementState } from '@tsin-states/administration-management/administration-management.state';
import { ExamFeeState } from '@tsin-states/exam-fees/exam-fees.state';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MyPreset } from '@tsin-shared/utils/theme';
import { RotationsState } from '@tsin-core/states/rotations/rotations.state';
import { AttendanceState } from '@tsin-core/states/attendance/attendance.state';
import { ApplicationState } from '@tsin-core/states/application/application.state';
import { InvoiceState } from '@tsin-core/states/invoices/invoices.state';



export const appConfig: ApplicationConfig = {
  providers: [
    provideExperimentalZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding(), withDebugTracing()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.my-app-dark'
        }
      }
    }),
    importProvidersFrom(
      BrowserAnimationsModule,
      NgxsLoggerPluginModule.forRoot({
        disabled: environment.production,
      }),
      NgxsReduxDevtoolsPluginModule.forRoot({
        disabled: environment.production,
      })
    ),
    provideHttpClient(withInterceptors([jwtInterceptor, loggingInterceptor])),
    provideStore(
      [
        AuthState,
        UserState,
        ExamState,
        TrackManagementState,
        StationManagementState,
        AdmninistrationManagementState,
        ExaminerState,
        ExamFeeState,
        ExamineeState,
        RotationsState,
        AttendanceState,
        ApplicationState,
        InvoiceState,
      ],
      {
        developmentMode: !environment.production,
      },
      withNgxsStoragePlugin({
        keys: [
          {
            key: 'userState.users',
            engine: LOCAL_STORAGE_ENGINE,
          },
          {
            key: 'authState.auth',
            engine: SESSION_STORAGE_ENGINE,
          },
          {
            key: 'examState.exams',
            engine: LOCAL_STORAGE_ENGINE,
          },
        ],
      })
    ),
  ],
};
